import React from "react";
import { AdminTicketing } from "./AdminTicketing";

/**
 * The four ticketing pages. They share one implementation because they share
 * their data — ticket types set the default prices a fixture overrides, and
 * competitions decide what a season ticket covers — so splitting the component
 * would only duplicate the loading.
 *
 * Each gets its own menu entry and route; the section prop picks the view.
 */
export class AdminTicketTypes extends React.Component {
	render() { return <AdminTicketing section="types" />; }
}

export class AdminFixtureTicketing extends React.Component {
	render() { return <AdminTicketing section="fixtures" />; }
}

export class AdminSeasonTickets extends React.Component {
	render() { return <AdminTicketing section="season" />; }
}

export class AdminCompetitions extends React.Component {
	render() { return <AdminTicketing section="competitions" />; }
}
